module.exports = __webpack_public_path__ + "img/box7-5-5.3770cfa2.png";